module.exports = __webpack_public_path__ + "assets/img/kefu1.a9bcbfda.png";